import React from 'react';
import masterService from '../../core/services/Common/MasterService';
import DataFeed from '../../core/services/Technical/DataFeed'; //Do not remove this line
import { SYMBOL_TYPES } from '../../core/services/Technical/DataFeed/Const'; //Do not remove this line
import { changeTheme, setUserInfo } from '../app/reducer';
import ChartingPreRender from '../common/ChartingPreRender';
import GuestPopup from '../common/guest-popup/GuestPopup';
import EventEmitter, { SHOW_GUEST_POPUP } from '../helpers/EventEmitter';
import TradingView from '../technical/charting/trading-view/TradingView';
import authProvider from './../../core/AuthenticationProvider';
import { setLocale } from 'react-redux-i18n';
import { connect } from 'react-redux';

const capitalizeFirstLetter = string => {
  if (!string) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

class Charting extends React.PureComponent {
  constructor(props) {
    super(props);

    this.rootRef = React.createRef();
    this.query = new URLSearchParams(window.location.search);
    this.props.setLocale(this.getLocale());
    this.props.changeTheme(this.getTheme());
    this.state = {
      isRender: this.getIsRender(),
      savedData: null,
      isLoadedUser: false,
      keyChart: 0,
      isShowGuestPopup: false,
    };
    authProvider.getUser().then(user => {
      this.setState({
        isLoadedUser: true,
      });
      this.props.setUserInfo(user);
    });
  }

  componentDidMount() {
    const { isRender } = this.state;
    if (!isRender) {
      this.getSharedTemplate();
    }
    EventEmitter.subscribe(SHOW_GUEST_POPUP, this.onShowGuestPopup);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SHOW_GUEST_POPUP, this.onShowGuestPopup);
  }

  onShowGuestPopup = () => {
    this.setState({ isShowGuestPopup: true });
  };

  loadUserAndRemountChart = () => {
    authProvider.getUser().then(user => {
      this.setState({
        user,
        keyChart: this.state.keyChart + 1,
      });
    });
  };

  getSharedTemplate = () => {
    const shareId = this.query.get('shareId');
    const chartLayoutId = this.query.get('chartLayoutId');
    const signature = this.query.get('signature');

    masterService
      .getSharedChartLayout({
        ShareId: shareId,
        ChartLayoutId: chartLayoutId,
        Signature: signature,
      })
      .then(res => {
        const chartState = JSON.parse(res.items[0].layout);
        if (chartState.theme) {
          this.props.changeTheme(chartState.theme);
        }
        this.setState({
          isRender: true,
          savedData: chartState,
        });
      });
  };

  getIsRender = () => {
    return !this.query.get('shareId');
  };

  getTheme = () => {
    return capitalizeFirstLetter(this.query.get('theme')) || 'Light';
  };

  getSymbol = () => {
    return this.query.get('code') || 'AAA';
  };

  getLocale = () => {
    return this.query.get('lang') || 'en';
  };

  showGuestPopup = (bool = true) => {
    this.setState({
      isShowGuestPopup: bool,
    });
  };

  render() {
    const {
      savedData,
      isRender,
      keyChart,
      isShowGuestPopup,
      isLoadedUser,
    } = this.state;
    const { user } = this.props;
    if (!isRender || !isLoadedUser) {
      return null;
    }

    return (
      <>
        <TradingView
          key={keyChart}
          loadUserAndRemountChart={this.loadUserAndRemountChart}
          user={user}
          isShareLink={!!this.query.get('shareId')}
          savedData={savedData}
          isNewWindow={true}
          defaultSymbol={this.getSymbol()}
        />
        {isShowGuestPopup && (
          <GuestPopup showGuestPopup={this.showGuestPopup} />
        )}
      </>
    );
  }
}

Charting.defaultProps = {
  interval: 'D',
  libraryPath: '/charting_library/',
  chartsStorageUrl: 'https://saveload.tradingview.com',
  chartsStorageApiVersion: '1.3',
  clientId: 'tradingview.com',
  userId: 'public_user_id',
  fullscreen: false,
};

const mapDispatchToProps = {
  setLocale,
  changeTheme,
  setUserInfo,
};

const ConnectedCharting = connect(
  null,
  mapDispatchToProps,
)(Charting);

export default () => (
  <ChartingPreRender>
    <div className="h-100 technical-charting ">
      <ConnectedCharting />
    </div>
  </ChartingPreRender>
);
